import React from 'react';
import PropTypes from 'prop-types';
import TextField from "@material-ui/core/TextField";

function CustomTextField({error, name, placeholder, errorMsg, type, value, onChange}) {
    return (
        <>
            <TextField variant={'outlined'} rowsMax={1} required={true}
                       fullWidth
                       placeholder={placeholder}
                       error={error}
                       value={value}
                       name={name}
                       helperText={errorMsg}
                       type={type}
                       onChange={onChange}/>
        </>
    );
}

CustomTextField.propTypes = {
    error: PropTypes.bool,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    errorMsg: PropTypes.string,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};
CustomTextField.defaultProps = {
    error: false,
    placeholder: "",
    errorMsg: "",
    type: "text",
};

export default CustomTextField;
